import React from 'react';
import Base from './Base';
import TodoCarousel from '../utils/TodoCarousel';
import "../styles.css";



const Home = () => {

    return (
        <Base title="Todo" description="Welcome! A One stop place to take a note of all your tasks">
            <div className='h-screen'>
                <div className="row text-center mb-6   xs:mb-6 sm:mb-6    md:mb-0  ">
                    <h1 className='text-white'>Todos</h1>
                    <div className="row">
                        <div>
                            <div className='text-xl py-2  xs:text-xl xs:pt-4 xs:pb-2   sm:text-xl sm:pt-6 sm:pb-2     md:text-2xl md:py-2    smLaptop:text-2xl smLaptop:py-2   lg:text-2xl lg:py-2    xl:text-2xl xl:pt-2 xl:pb-4  text-[#5f7ac2] text-center drop-shadow-lg font-bold'>TodoMate <span className='text-lg font-semibold'> -  A one stop place for all your Todos! </span> </div>
                            <div>
                                <TodoCarousel />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Base>
    )
}



export default Home;